import { toast } from "sonner";
import { adminOpenPortal, errorMessage } from "@/lib/api";

/** «Sjå som arrangør»: open the tab first (user gesture), then point it at the board session. */
export const openOrganizerPortal = async (oid, eventId) => {
  const w = window.open("", "_blank");
  try {
    const r = await adminOpenPortal(oid, eventId ? { event_id: eventId } : {});
    const url = r.url || `${window.location.origin}${r.path}`;
    if (w) w.location = url; else window.location.assign(url);
    toast.success(`Arrangørsida til ${r.organizer.name} er opna som styret`, { description: `Økta gjeld i ${Math.round(r.expires_minutes / 60)} timar og vert logga som styret.` });
  } catch (e) {
    if (w) w.close();
    toast.error(errorMessage(e, "Kunne ikkje opne arrangørsida"));
  }
};
